export default "__VITE_ASSET__BXPsA_rP__"